import {useDispatch} from 'react-redux';
import {useApiMutation} from 'src/hooks/useApiMutation';
import * as reduxApi from 'src/utils/redux-api-v2';
import type {SetDefaultResponse} from 'src/types/byod';
import {BYOD_API_BASE as BASE} from 'src/components/analytics-genesis/byod/api';
import {useByodMutationErrorHandler} from 'src/components/analytics-genesis/byod/api/error-handling';


type SetGroupDefaultRequest = {
  dashboardId: string;
  remove?: boolean;
};

export function useSetGroupDefaultDashboard() {
  const dispatch = useDispatch();
  const onError = useByodMutationErrorHandler('set group default dashboard');

  return useApiMutation<SetDefaultResponse, Error, SetGroupDefaultRequest>({
    mutationFn: ({dashboardId, remove}) => {
      const encodedId = encodeURIComponent(dashboardId);
      return dispatch(
        remove
          ? reduxApi.del(`${BASE}/dashboards/${encodedId}/default/group`)
          : reduxApi.put(`${BASE}/dashboards/${encodedId}/default/group`, {}),
      ) as Promise<SetDefaultResponse>;
    },
    onError,
  });
}
